import { remove } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { z } from "zod";

import { getWorkplaceStarredProfessionalsUrl } from "./useGetWorkplaceStarredProfessionals";

export function useDeleteStarredProfessional(params: {
  workplaceId: string;
  starredProfessionalId?: string;
}) {
  const { workplaceId, starredProfessionalId: defaultStarredProfessionalId } = params;
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (starredProfessionalId?: string) => {
      const effectiveStarredProfessionalId = starredProfessionalId ?? defaultStarredProfessionalId;

      if (!effectiveStarredProfessionalId) {
        throw new Error("Missing starred professional id");
      }

      await remove({
        url: `${environmentConfig.REACT_APP_BASE_API_URL}/workplaces/${workplaceId}/starred-professionals/${effectiveStarredProfessionalId}`,
        responseSchema: z.literal(""),
      });
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [getWorkplaceStarredProfessionalsUrl(workplaceId)],
      });
    },
    meta: {
      userSuccessMessage: "Professional removed from your starred list",
      logErrorMessage: APP_V2_APP_EVENTS.DELETE_WORKPLACE_STARRED_PROFESSIONAL_FAILURE,
      userErrorMessage:
        "There was an error removing this professional from your starred list. Please try again later.",
    },
  });
}
